function filterSlideUpDownToggle(btn){
    $('.mdl .js-select-filter-wrap .selection').not(btn).siblings('.dropdown-wrapper').slideUp(function(){
        $(this).closest('.select2-container').removeClass('opened');
    });

    let thisWrapper;

    thisWrapper = btn.siblings('.dropdown-wrapper');

    thisWrapper.slideToggle('linear', function(){
        if(thisWrapper.is(':visible')){
            thisWrapper.closest('.select2-container').addClass('opened');
            thisWrapper.css('display', 'block');
        } else {
            thisWrapper.closest('.select2-container').removeClass('opened');
        }
    });
};

$(document).on('click', '.mdl .js-select-filter-wrap .selection', function(){
    filterSlideUpDownToggle($(this));

    $('.js-dropdown-filter').slideUp();
    $('.js-tod-filter-result-btn').removeClass('active');
});


function rangeFilterDropdownToggle(){
    $(document, '.mdl-wrap').on("click touch", "*[data-drop-filter]", function () {
        var target = $(this).attr("data-drop-filter");

        if(window.matchMedia(`(min-width: 600px)`).matches) {
            $(".js-dropdown-filter:not(#" + target + ")").removeClass("active");
            $("*[data-drop-filter]").not(this).removeClass("active");
            if (!$("#" + target).hasClass("active")) {
                $("#" + target).addClass("active");
                $(this).addClass("active");
            } else {
                $("#" + target).removeClass("active");
                $(this).removeClass("active");
            }
        } else {
            $(this).toggleClass('active');
            $(`#${target}`).slideToggle();

            $('.mdl .js-select-filter-wrap .selection').siblings('.dropdown-wrapper').slideUp(function(){
                $(this).closest('.select2-container').removeClass('opened');
            });
        }
    });
    

    if(window.matchMedia(`(min-width: 600px)`).matches){
        $(document, '.mdl-wrap').on("mousedown touch", function (event) {
            if ($(event.target).closest("*[data-drop-filter]").length) {
                return;
            }
            $(".js-dropdown-filter").removeClass("active");
            $("*[data-drop-filter]").removeClass("active");
        });
        
        $(document, '.mdl-wrap').on("mousedown touch", ".js-dropdown-filter", function (event) {
            if ($(".js-dropdown-filter").hasClass("active")) {
                event.stopPropagation();
            }
        });
    }
}

runIfElementExist(rangeFilterDropdownToggle, '.js-select-filter-wrap');

